import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass([
			{
				'items-center space-x-2 flex flex-row cursor-pointer text-white hover:text-gray-200 ': true,
			},
		])
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BackButton',
  props: {
		backAction: {
			type: Function,
			default: () => {
				// Code here
			},
		},
		label: {
			type: String,
			default: "Default Label",
		},
		src: {
			type: String,
			default: "/media/icons/arrow-left-icon.svg",
		},
		css: {
			type: String,
			default: "",
		},
	},
  setup(__props) {

	

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      src: __props.src,
      css: __props.css
    }, null, 8, ["src", "css"]),
    _createElementVNode("span", null, _toDisplayString(__props.label), 1)
  ]))
}
}

})